/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ecash_Chain_Max_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "eCash operates as a PoW network, where block times vary significantly due to the nature of the mining process. In some cases, when a miner solves the cryptog..." |
*
* @param {Ecash_Chain_Max_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ecash_chain_max_tps_explanation = /** @type {((inputs?: Ecash_Chain_Max_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ecash_Chain_Max_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("eCash operates as a PoW network, where block times vary significantly due to the nature of the mining process. In some cases, when a miner solves the cryptographic puzzle unusually quickly, a new block can be created in just seconds.<br /><br />This variability explains why eCash’s <strong>Max TPS (1 block)</strong> can exceed its <strong>Max Theoretical TPS</strong>.")
});